import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-725fe381"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "detail_box"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "config-info"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-line"
}, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title-line"
}, null, -1));
const _hoisted_6 = {
  class: "item-title"
};
const _hoisted_7 = {
  key: 0,
  class: "item-content"
};
const _hoisted_8 = {
  key: 0,
  class: "action-info"
};
const _hoisted_9 = {
  class: "btn-info"
};
const _hoisted_10 = ["onClick"];
import { computed, onMounted, reactive } from "vue";
import { useRoute } from "vue-router";
import domain from "@/service/domain";
import router from '@/router';
import { getUserPromotionDetail, cancelUserPromotion } from "@/api";
import { mdAlert, mdToast } from "../../utils/tools";
export default {
  setup(__props) {
    const route = useRoute();
    const state = reactive({
      exchange_id: 0,
      record_id: 0,
      status: -1,
      config_list: [],
      start_time: '',
      goldTotal: 0
    });
    onMounted(() => {
      document.title = '推广详情';
      state.record_id = route.params.id;
      sendUserPromotionDetailRequest();
    });
    const cancelEnabled = computed(() => {
      // 短信推广-不可取消
      if (state.exchange_id == 3) {
        return false;
      }

      // 非 待审核&审核通过-不可取消
      if (state.status != 0 && state.status != 10) {
        return false;
      }
      const start_date = new Date(state.start_time);
      const current_date = new Date();

      // 正在推广-不可取消
      if (start_date <= current_date) {
        return false;
      }
      return true;
    });
    async function sendUserPromotionDetailRequest() {
      const {
        status,
        data,
        message
      } = await getUserPromotionDetail({
        'record_id': state.record_id
      });
      if (status == 0) {
        // --------------顶部数组------------

        // status 0待审核 10审核通过 20已结束 30已取消
        state.status = data.status;
        state.exchange_id = data.exchange_id;
        state.config_list = [];
        var show_pro = true;
        var show_calendar_date = false;
        var show_cover = false;

        // mark 只有短信没有项目，其他都显示项目信息
        // 1 PC官网在线项目 2 众筹页編辑推荐 3 更新短信推广-兑换服务 4 PUSH推广-兑换服务  5 PC官网首页banner 6 搜索关键词 7 众筹页Banner 8 首页Banner
        switch (Number(state.exchange_id)) {
          case 1:
          case 2:
          case 6:
            {
              show_calendar_date = true;
            }
            break;
          case 3:
            {
              show_pro = false;
            }
            break;
          case 5:
          case 7:
          case 8:
            {
              show_calendar_date = true;
              show_cover = true;
            }
            break;
          default:
            break;
        }

        //推广位置/兑换服务
        if (data.title) {
          // 1 PC官网在线项目 2 众筹页編辑推荐 3 更新短信推广-兑换服务 4 PUSH推广-兑换服务  5 PC官网首页banner 6 搜索关键词 7 众筹页Banner 8 首页Banner
          var title = '推广位置';
          if (data.exchange_id == 3 || data.exchange_id == 4) {
            title = '兑换服务';
          }
          var content = data.title;
          if (data.exchange_id == 3) {
            content = data.sms_count ? data.title + data.sms_count + '条' : data.title;
          }

          // 示例
          var show_demo = false;
          if (data.exchange_id == 1 || data.exchange_id == 2 || data.exchange_id == 5 || data.exchange_id == 6 || data.exchange_id == 7 || data.exchange_id == 8) {
            show_demo = true;
          }
          var show_sms_demo = false;
          if (data.exchange_id == 3) {
            show_sms_demo = true;
          }
          state.config_list.push({
            'type': 'title',
            'title': title,
            'content': content,
            show_demo: show_demo,
            show_sms_demo: show_sms_demo
          });
        }

        // 推广项目
        if (data.pro_title && data.pro_title.length > 0 && show_pro) {
          state.config_list.push({
            'type': 'pro_title',
            'title': '推广项目',
            'content': data.pro_title
          });
        }

        // 预约时间
        if (data.start_time && data.start_time.length > 0 && show_calendar_date) {
          state.start_time = data.start_time;
          state.config_list.push({
            'type': 'calendar_date',
            'title': '预约时间',
            'content': `${data.start_time}至${data.end_time}`
          });
        }

        // 关键词
        if (data.key_word && data.key_word.length > 0) {
          state.config_list.push({
            'type': 'keyword',
            'title': '关键词',
            'content': data.key_word
          });
        }

        // 广告素材
        if (data.img && data.img.length > 0 && show_cover) {
          state.config_list.push({
            'type': 'pro_cover',
            'title': '广告素材',
            'content': data.img
          });
        }

        // push
        if (state.exchange_id == 4) {
          // 推送-预约时间
          if (data.push_time && data.push_time.length > 0) {
            state.config_list.push({
              'type': 'push_date',
              'title': '预约时间',
              'content': data.push_time
            });
          }
          // 推送标题
          if (data.push_title && data.push_title.length > 0) {
            state.config_list.push({
              'type': 'push_title',
              'title': 'Push标题',
              'content': data.push_title
            });
          }

          // 推送内容
          if (data.push_content && data.push_content.length > 0) {
            state.config_list.push({
              'type': 'push_content',
              'title': 'Push内容',
              'content': data.push_content
            });
          }
        }

        // 推广金币 
        if (data.prize && data.prize > 0) {
          state.goldTotal = data.prize;
          state.config_list.push({
            'type': 'prize',
            'title': '推广金币',
            'content': data.prize + '金币'
          });
        }

        // 返回金币
        if (data.back_prize && data.back_prize > 0) {
          state.config_list.push({
            'type': 'back_prize',
            'title': '返还金币',
            'content': data.back_prize + '金币'
          });
        }
      } else {
        mdToast(message);
      }
    }
    function handleDemoAction() {
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `${domain.wap}/score/promotion/demo?exchange_id=${state.exchange_id}`,
        webFun: () => {
          router.push(`/score/promotion/demo?exchange_id=${state.exchange_id}`);
        }
      });
    }
    function handleSMSDemoAction() {
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `${domain.wap}/score/promotion/sms_demo`,
        webFun: () => {
          router.push(`/score/promotion/sms_demo`);
        }
      });
    }
    function statusNameFormatter(status) {
      var status_name = '';
      switch (Number(status)) {
        case 0:
          status_name = '待审核';
          break;
        case 10:
          status_name = '进行中';
          break;
        case 20:
          status_name = '已完成';
          break;
        case 1:
        case 2:
          status_name = '审核拒绝';
          break;
        case 30:
          status_name = '已取消';
          break;
        default:
          break;
      }
      return status_name;
    }
    function statusNameStyle(status) {
      let style = {
        'color': '#7F7F7F'
      };
      switch (status) {
        case 0:
          //待审核
          style = {
            'color': '#FF3535'
          };
          break;
        case 10:
          {
            // 进行中
            style = {
              'color': '#00C4A1'
            };
          }
          break;
        case 3:
        case 4:
        default:
          break;
      }
      return style;
    }

    //预约推广
    function handlePromotionAction() {
      // 1 PC官网在线项目 2 众筹页編辑推荐 3 更新短信推广-兑换服务 4 PUSH推广-兑换服务  5 PC官网首页banner 6 搜索关键词 7 众筹页Banner 8 首页Banner

      // status 0待审核 10审核通过 20已结束 30已取消
      // 提交预约推广时，待审核可取消预约，取消扣除20%的金币；

      // 通过审核状态为进行中的可取消预约，取消扣除60%的金币；
      const deduction = state.status == 10 ? '60%' : '20%';
      var alert_title = '确定取消预约';
      var alert_content = `本次推广消耗${state.goldTotal}金币，若取消推广将扣除本次扣除${deduction}的金币，确定要取消推广吗？`;
      var alert_actions = ['取消', '确定'];
      mdAlert({
        title: alert_title,
        content: alert_content,
        actions: alert_actions,
        _callback: () => {
          //取消兑换请求
          sendCancelPromotionRequest();
        }
      });
    }
    async function sendCancelPromotionRequest() {
      const {
        status,
        message
      } = await cancelUserPromotion({
        record_id: state.record_id
      });
      if (status == 0) {
        sendUserPromotionDetailRequest();
        mdToast('取消成功');
      } else {
        mdToast(message);
      }
    }
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", {
        class: "title",
        style: _normalizeStyle(statusNameStyle(_unref(state).status))
      }, _toDisplayString(statusNameFormatter(_unref(state).status)), 5), _hoisted_5, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).config_list, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "config-item",
          key: index
        }, [_createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1), item.type != 'pro_cover' ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(item.content), 1)) : item.type == 'pro_cover' ? (_openBlock(), _createBlock(_component_van_image, {
          key: 1,
          class: "cover",
          src: _ctx.$imgUrlFilter(item.content, 420)
        }, null, 8, ["src"])) : _createCommentVNode("", true), item.type == 'title' && item.show_demo ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "example-info",
          onClick: _cache[0] || (_cache[0] = _withModifiers($event => handleDemoAction(), ["stop"]))
        }, " 示例 ")) : item.type == 'title' && item.show_sms_demo ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "example-info",
          onClick: _cache[1] || (_cache[1] = _withModifiers($event => handleSMSDemoAction(), ["stop"]))
        }, " 教程 ")) : _createCommentVNode("", true)]);
      }), 128))])]), _unref(cancelEnabled) ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
        class: "action-btn",
        onClick: _withModifiers(handlePromotionAction, ["stop"])
      }, "取消预约", 8, _hoisted_10)])])) : _createCommentVNode("", true)]);
    };
  }
};